import { Pipe, PipeTransform } from '@angular/core';
import { isBatchedRawMode } from '../utils/raw-mode.utils';

@Pipe({
    name: 'isBatchedRawMode',
    pure: true,
    standalone: false
})
export class IsBatchedRawModePipe implements PipeTransform {
    transform(value: any) {
        return typeof value === 'string' && isBatchedRawMode(value);
    }
}
